
import SceneTextureDialog from './SceneTextureDialog.vue';
import _get from 'lodash/get';
import _set from 'lodash/set';

export default {
  components: {
    SceneTextureDialog: SceneTextureDialog
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectTexture: function selectTexture() {
      if (!this.config.prop) return null;
      return _get(this.model, this.config.prop);
    },
    currentSrc: function currentSrc() {
      if (!this.selectTexture) return false;
      return this.selectTexture ? this.selectTexture.atlas.img.currentSrc : null;
    }
  },
  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    openSceneTextureDialog: function openSceneTextureDialog() {
      this.$refs.SceneTextureDialog.openDialog();
    },
    selectTextureHandler: function selectTextureHandler(texture) {
      var prop = this.realProp();
      _set(this.model.script, prop, texture);
      _set(this.model, this.config.prop, texture);
    }
  }
};